<section class="w-full h-full bg-white md:px-10 md:py-16 px-4 py-8 overflow-x-hidden">
  <div class="container mx-auto h-full w-full">
    <div
      class="flex md:flex-row flex-col justify-between md:gap-14 gap-8 items-center h-full w-full"
    >
      <div
        appScrollAnimate="animate-move-in-right"
        [scrollThreshold]="0"
        class="max-md:w-full w-1/2 h-full rounded-2xl overflow-hidden"
      >
        <img src="lite/lite_2.jpg" alt="detail Image" class="w-full h-full object-cover" />
      </div>

      <div
        appScrollAnimate="animate-move-in-left"
        [scrollThreshold]="0"
        class="flex flex-col items-start justify-center max-md:w-full w-1/2"
      >
        <h2
          i18n="lite.detail|Round up your crew and play heading@@lite.detail.title"
          class="md:text-3xl text-2xl font-bold text-main-blue-light"
        >
          Round up your crew and play
        </h2>
        <p
          i18n="lite.detail|Create, Invite, and Join heading@@lite.detail.createInviteJoin"
          class="text-main-black text-sm md:text-base font-medium"
        >
          Create, Invite, and Join
        </p>
        <p
          i18n="
            lite.detail|Set the game up in seconds, invite your players group, and watch the
            headcount grow description@@lite.detail.description"
          class="text-[#9B9B9B] text-lg md:text-xl mt-6"
        >
          Set the game up in seconds, invite your players group, and watch the headcount grow.
        </p>
      </div>
    </div>
  </div>
</section>
